import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CheckoutState {
    isCheckoutOpen: boolean;
}

const initialState: CheckoutState = {
    isCheckoutOpen: false,
}

const checkoutSlice = createSlice({
    name: "CheckoutState",
    initialState,
    reducers: {
        setCheckoutVisibility: (state, action: PayloadAction<boolean>) => {
            state.isCheckoutOpen = action.payload;
        },
        toggleCheckoutVisibility: (state) => {
            state.isCheckoutOpen = !state.isCheckoutOpen;
        },
    }
});

export const { setCheckoutVisibility, toggleCheckoutVisibility} = checkoutSlice.actions;
export default checkoutSlice.reducer;